<script lang="ts">
import { defineComponent } from "vue";
/**
 * Preloader component
 */
export default defineComponent({
  name: "LoaderWidget",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: "",
    },
    textTop: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    noRow: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<template>
  <div class="loader-wrapper" :class="[noRow ? '' : 'row']">
    <div v-if="loading" class="preloader-component" :class="classes">
      <div class="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
      <div
        v-if="text"
        :class="
          'loader-text ' + (textTop ? 'loader-text-top' : 'loader-text-bottom')
        "
      >
        <h3 v-html="text"></h3>
      </div>
    </div>
    <slot />
  </div>
</template>

<style scoped lang="scss">
.loader-wrapper {
  position: relative;
  padding: 0;
  margin: 0;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bs-body-bg);
  z-index: 4;
  width: 100%;
  &.opaque {
    background: #ffffffcc;
  }
}

.preloader-component.transparent-load {
  opacity: 0.7;
}

.transparent-load .status {
  top: 20% !important;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: 3px 0 0 -20px;
}

.loader-text {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
}
.loader-text-bottom {
  bottom: 10%;
}
.loader-text-top {
  top: 20%;
}
</style>
